
export type CustomMultiValueMoreSelectedBadgeProps = {
  items: string[];
};

const AdditionalOptionsPill = ({ items }: CustomMultiValueMoreSelectedBadgeProps) => {
  const title = items.join(", ");
  const length = items.length;
  const label = `+ ${length} item${length !== 1 ? "s" : ""} selected`;

  return (
    <div className="ml-auto bg-[#d4eefa] rounded-[4px] font-sans text-[11px] p-[3px] order-[99]" title={title}>
      {label}
    </div>
  );
};

export default AdditionalOptionsPill;
